module.exports = __webpack_public_path__ + "img/stores_personal_consultation@2x.b5570b3.webp";